import React from 'react';
import styled from 'styled-components';
import MotifProgressIndicator from '@ey/motif-react-wrapper/ProgressIndicator';

export default function ProgressIndicator(props) {
	const {id, className, variant, children} = props;
	return (
		<StyledMotifProgressIndicator id={id} className={className} variant={variant}>
			{children}
		</StyledMotifProgressIndicator>
	);
}

const StyledMotifProgressIndicator = styled(MotifProgressIndicator)``;
